import React from 'react';
export function NamingRules() {
  return <div data-id="element-2412">
      <div className="flex justify-between items-center mb-6" data-id="element-2413">
        <h1 className="text-2xl font-bold" data-id="element-2414">Naming Rules</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2415">
          Save Changes
        </button>
      </div>
      <div className="bg-white rounded-lg shadow p-6" data-id="element-2416">
        <h2 className="text-lg font-medium mb-4" data-id="element-2417">
          Document Naming Conventions
        </h2>
        <div className="space-y-4" data-id="element-2418">
          <div data-id="element-2419">
            <label className="block text-sm font-medium mb-1" htmlFor="policyFormat" data-id="element-2420">
              Policy Documents
            </label>
            <input id="policyFormat" type="text" className="w-full border border-neutral-300 rounded p-2" defaultValue="[ClientName]_[PolicyType]_Policy_[Date]" data-id="element-2421" />
            <p className="text-xs text-neutral-500 mt-1" data-id="element-2422">
              Example: JohnDoe_Auto_Policy_2023-01-15
            </p>
          </div>
          <div data-id="element-2423">
            <label className="block text-sm font-medium mb-1" htmlFor="claimFormat" data-id="element-2424">
              Claim Documents
            </label>
            <input id="claimFormat" type="text" className="w-full border border-neutral-300 rounded p-2" defaultValue="[ClientName]_[PolicyType]_Claim_[ClaimNumber]_[Date]" data-id="element-2425" />
            <p className="text-xs text-neutral-500 mt-1" data-id="element-2426">
              Example: JohnDoe_Auto_Claim_C12345_2023-01-15
            </p>
          </div>
          <div data-id="element-2427">
            <label className="block text-sm font-medium mb-1" htmlFor="renewalFormat" data-id="element-2428">
              Renewal Documents
            </label>
            <input id="renewalFormat" type="text" className="w-full border border-neutral-300 rounded p-2" defaultValue="[ClientName]_[PolicyType]_Renewal_[Date]" data-id="element-2429" />
            <p className="text-xs text-neutral-500 mt-1" data-id="element-2430">
              Example: JohnDoe_Auto_Renewal_2023-01-15
            </p>
          </div>
        </div>
      </div>
    </div>;
}